import { Stack, MessageBar, MessageBarType } from '@fluentui/react'
import { PerformanceData } from '../../state/AppProvider'
import LoadingSpinner from '../common/LoadingSpinner'
import { PerformanceDataState } from './usePerformanceData'
import LatencyTiles from './LatencyTiles'
import StageBreakdownChart from './StageBreakdownChart'
import OutcomesChart from './OutcomesChart'
import TokenSpendPanel from './TokenSpendPanel'
import SlowestAnswersTable from './SlowestAnswersTable'
import RecentMessagesTable from './RecentMessagesTable'

type PerformanceReportProps = {
  performance: PerformanceDataState
}

const PerformancePanels = ({ data }: { data: PerformanceData }) => (
  <Stack tokens={{ childrenGap: 20 }}>
    <LatencyTiles answerCount={data.summary.answer_count} latency={data.summary.latency} />
    <Stack horizontal tokens={{ childrenGap: 20 }} styles={{ root: { flexWrap: 'wrap' } }}>
      <StageBreakdownChart stages={data.summary.stages} />
      <OutcomesChart outcomes={data.summary.outcomes} />
    </Stack>
    <TokenSpendPanel tokens={data.summary.tokens} pricing={data.summary.pricing} />
    <SlowestAnswersTable items={data.slowest} costBasis={data.slowestCostBasis} />
    <RecentMessagesTable items={data.recentMessages} costBasis={data.recentMessagesCostBasis} />
  </Stack>
)

const PerformanceReport = ({ performance }: PerformanceReportProps) => {
  switch (performance.status) {
    case 'loading':
      return <LoadingSpinner label="Loading performance data..." />
    case 'error':
      return <MessageBar messageBarType={MessageBarType.error}>{performance.message}</MessageBar>
    case 'loaded':
      return performance.data.telemetryAvailable ? (
        <PerformancePanels data={performance.data} />
      ) : (
        <MessageBar messageBarType={MessageBarType.info}>
          Performance telemetry isn't recorded in this environment yet.
        </MessageBar>
      )
  }
}

export default PerformanceReport
